<template>
  <div class="room-modal">
    <room-carousel :images="room.images" />
    <p class="room-modal__title" v-if="room.images.length">{{ room.name }}</p>
    <p class="room-modal__desc" v-html="room.descriptions.overview" />
    <room-info class="room-modal__info" :room="room" />
    <div class="room-modal__amenities" :class="show_amenities && 'room-modal__amenities--open'">
      <p class="room-modal__amenities-title">Servizi</p>
      <ul class="room-modal__amenities-list">
        <li
          class="room-modal__amenities-list_item"
          v-for="(amenity, amenity_index) in amenities"
          :key="_uid + 'amenity' + amenity_index"
        >
          <amenity :item="amenity" :type="'rooms'" />
        </li>
      </ul>
    </div>
    <span
      class="room-modal__show"
      v-if="amenities.length > 15"
      v-html="!show_amenities ? 'vedi tutti' : 'chiudi'"
      @click="toggle_amenities()"
    />
  </div>
</template>

<script>
import { get_amenities_rooms } from '@liveeps/resources'
import RoomCarousel from '@liveeps/components/blocks/detail/room/room-carousel'
import RoomInfo from '@liveeps/components/blocks/detail/room/room-info'
import Amenity from "@liveeps/components/atoms/amenity"

export default {
  name: 'room-modal',

  components: {
    'room-carousel': RoomCarousel,
    'room-info': RoomInfo,
    'amenity': Amenity,
  },

  props: {
    room: Object
  },

  data() {
    return {
      show_amenities: false
    }
  },

  computed: {
    amenities() {
      return Object.values(this.room.amenities || {});
    }
  },

  created() {
    this.get_amenities_rooms = get_amenities_rooms
  },

  mounted() {
  },

  methods: {
    toggle_amenities() {
      this.show_amenities = !this.show_amenities
    },
  },
}
</script>

<style lang="scss" scoped>

  .room-modal {

    &__title {
      font-size: $font-size-xl;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: $grid-gutter-width / 2;
    }

    &__desc {
      margin-bottom: 0;

      ::v-deep {

        br {
          display: none;
        }

        strong, b {
          font-weight: $vb-font-weight-semibold;
        }

        p {
          margin-bottom: $grid-gutter-width / 3;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    &__info {
      margin-top: $grid-gutter-width;
    }

    &__amenities {
      border-top: 1px solid $gray-200;
      margin-top: $grid-gutter-20;
      padding-top: $grid-gutter-20;
      max-height: 210px;
      overflow: hidden;

      &--open {
        max-height: none;
      }

      &-title {
        font-size: $font-size-lg;
        font-weight: $vb-font-weight-semibold;
        margin-bottom: $grid-gutter-width / 2;
      }

      &-list {
        padding: 0;
        margin: 0;
        display: flex;
        flex-wrap: wrap;

        &_item {
          list-style: none;
          line-height: normal;
          margin: $grid-gutter-width / 5 0;
          width: 100%;
          display: flex;
          align-items: center;
          font-size: $font-size-md;

          @include media-breakpoint-up(md) {
            width: 50%;
          }

          @include media-breakpoint-up(lg) {
            width: 32%;
          }
        }

        &_icon {
          margin-top: 2px;
          margin-right: $grid-gutter-width / 3;
        }

        &_text {
          padding-right:  $grid-gutter-width / 2;
        }
      }
    }

    &__show {
      display: block;
      text-align: center;
      color: var(--info);
      text-decoration: underline;
      font-size: $font-size-md;
      cursor: pointer;
      justify-content: flex-end;
      margin-top: $grid-gutter-width / 2;
    }

    ::v-deep {
      .room-info {
        &__name {
          font-size: $font-size-md;
        }
      }
    }
  }

</style>